import React, { Component } from "react";
import { ThumbnailLocal } from "./Thumbnail";
import { FieldArray } from "formik";
import accepts from "attr-accept";
import Humanize from "humanize-plus";
import Compressor from "compressorjs";
import Alerts from "../../util/Alerts";
import { Label, Row } from "reactstrap";
import { BlkField } from "../BlkField";
import "./style.scss";

const ACCEPT =
    "image/jpeg,image/png,image/bmp," + // .jpg .jpeg .png .bmp
    "application/pdf,";

export class ArchivoUpload extends Component {
    constructor(props) {
        super(props);
        this.input = React.createRef();
        this.alert = React.createRef();
        this.state = {};

        let maxFileSize = this.props.maxFileSize + "";
        if (maxFileSize.indexOf("MB") >= 0) {
            maxFileSize = maxFileSize.replace("MB", "") * 1024 * 1024; //(bytes) = 2MB
        }
        this.maxSize = maxFileSize;
    }

    onChange = () => {
        let files = this.props.values.files || [];
        let fileSize = 0;
        const comprimir = async () => {
            for (const file of Array.from(this.input.current.files)) {
                const fileSizeCondition = this.maxSize && file.size ? file.size <= this.maxSize : true;
                if (accepts(file, ACCEPT) && fileSizeCondition) {
                    files.push(file);
                    fileSize = file.size;
                } else if (accepts(file, ACCEPT) && file.type.toString().toLowerCase().indexOf("image") >= 0) {
                    const compres = await new Promise((resolve, reject) => {
                        new Compressor(file, {
                            maxWidth: 5000,
                            convertSize: 2000000,
                            success(result) {
                                resolve(result);
                            },
                            error(error) {
                                console.log("Error", error);
                                reject(null);
                            },
                        });
                    });
                    if (compres) {
                        files.push(compres);
                        fileSize = compres.size;
                    } else {
                        this.alert.current.show_error("La imagen no pudo ser cargada.");
                    }
                }
            }
        };
        comprimir().then(() => {
            this.props.setFieldValue("files", files);
            this.props?.handleTotalSize(fileSize, "+");
        });
    };

    render() {
        let values = this.props.values;
        let sizex = (this.props.values.files || []).length;
        return (
            <>
                <Alerts ref={this.alert} />
                <br />
                <FieldArray name="files">
                    {({ remove }) =>
                        (values.files || []).map((archivo, index) => (
                            <div className="form-group" key={index}>
                                <Label>Nombre: </Label>
                                <Row>
                                    <div className="col-lg-6">
                                        <BlkField
                                            name={`files[${index}].name`}
                                            className="form-control st-312"
                                            type="text"
                                            placeholder="Nombre Documento"
                                            autoFocus={true}
                                        />
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="actions pull-right">
                                            <button
                                                type="button"
                                                className="btn badge-neutral"
                                                onClick={() => {
                                                    this.props?.handleTotalSize(archivo.size, "-");
                                                    remove(index);
                                                }}
                                            >
                                                <i className="fas fa-trash-alt m-1" title={"Eliminar"} />
                                                <span className="m-1">Eliminar</span>
                                            </button>
                                        </div>
                                    </div>
                                </Row>
                                <div>
                                    <ThumbnailLocal key={index} archivo={archivo} />
                                </div>
                                <hr className={"border border-bottom  border-white"} />
                            </div>
                        ))
                    }
                </FieldArray>

                {sizex < 10 && (
                    <div className={"jedai-dd"}>
                        <div className={"ddx"}>
                            <input type="file" multiple accept={ACCEPT} ref={this.input} onChange={this.onChange} />
                        </div>
                        <button type="button" className="form-control mt-1" onClick={() => this.input.current.click()}>
                            Agregar {this.maxSize ? `(máximo ${Humanize.fileSize(this.maxSize)})` : ""}
                        </button>
                    </div>
                )}
                {sizex >= 10 && <span>Máximo 15 archivos</span>}
            </>
        );
    }
}
